<script setup>
import { ref } from "vue";
import { useToast } from "primevue/usetoast";
import { rejectReasons } from "~/constants";

const { applicationId } = defineProps({
  applicationId: String,
});

const emit = defineEmits(["close"]);
const drop_out_reason = ref("");
const toast = useToast();

const handleContactUnilinks = () => {
  const email = "info@unilinks.co";
  const subject = encodeURIComponent("Inquiry Regarding Declining Offer");
  const body = encodeURIComponent(
    `Dear UniLinks,\n\nI have concerns about declining my application and would like to discuss possible options.\n\nBest regards,`
  );

  window.open(
    `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`,
    "_blank"
  );
};

const onUpdateResponse = () => {
  refreshNuxtData("student-application-detail");
  isLoading.value = false;
  toast.add({
    severity: "success",
    summary: "Successfully updated to consulted status.",
    life: 3000,
  });
};

const handleDeleteApplication = async () => {
  if (!drop_out_reason.value.trim()) {
    toast.add({
      severity: "error",
      summary: "Missing Reason",
      detail: "Please provide a reason before declining the offer.",
      life: 3000,
    });
    return;
  }

  await useApiFetch(`student-applications/${applicationId}/student/dropout`, {
    method: "POST",
    body: {
      drop_out_reason: drop_out_reason.value,
    },
    onResponse() {
      emit("close");
      toast.add({
        severity: "info",
        summary: "Application Declined",
        detail: "Your request to decline the offer has been sent.",
        life: 3000,
      });
      refreshNuxtData("my-applications");
      refreshNuxtData("booked-applications");
      refreshNuxtData("profile-overview");
      onUpdateResponse();
    },
  });
};
</script>

<template>
  <div class="px-7 pb-7 bg-white shadow-md rounded-md">
    <p class="text-sm text-muted mb-3 px-1">
      Are you sure you want to decline this offer? Or, would you still want to
      consult with UniLinks for more information?
    </p>

    <SelectWithOther
      class="!px-0"
      :options="rejectReasons"
      @onChange="(value) => (drop_out_reason = value)"
    />
    <div class="flex justify-end gap-2 mt-4">
      <!-- <Button
        outlined
        label="Contact UniLinks"
        @click="handleContactUnilinks"
      ></Button> -->
      <Button
        outlined
        label="Cancel"
        @click="emit('close')"
      ></Button>
      <Button
        severity="danger"
        label="I am sure. I want to decline."
        @click="handleDeleteApplication"
        :disabled="!drop_out_reason"
      ></Button>
    </div>
  </div>
</template>
